import { cn } from '#pie/utils/TailwindUtils';

export interface DividerProps {
  className?: string;
}

export function Divider({ className }: DividerProps) {
  return (
    <hr
      className={cn('my-0 h-px w-full border-0 bg-border-divider', className)}
    />
  );
}
